export var MuiBreadcrumbs = {
    separator: '›',
    color: 'initial',
};
//# sourceMappingURL=MuiBreadcrumbs.js.map